<template>
  <div class="app-container group-buy-page">
    <div class="page-heading">
      <div><h2>拼团活动列表</h2><p>配置拼团规则、活动商品与 SKU 价格库存</p></div>
      <el-button type="primary" icon="el-icon-plus" @click="openEditor()">新增拼团活动</el-button>
    </div>
    <el-card shadow="never" class="filter-card">
      <el-form :inline="true" :model="query" size="small">
        <el-form-item label="活动名称"><el-input v-model.trim="query.name" clearable placeholder="请输入活动名称" @keyup.enter.native="search" /></el-form-item>
        <el-form-item label="活动状态">
          <el-select v-model="query.phase" clearable placeholder="全部状态">
            <el-option v-for="item in phases" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button><el-button icon="el-icon-refresh" @click="reset">重置</el-button></el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never" class="table-card">
      <el-table v-loading="loading" :data="list" border size="small">
        <el-table-column label="活动名称 / 商品" min-width="220">
          <template slot-scope="scope"><div class="primary-text">{{ scope.row.name }}</div><div class="secondary-text">共 {{ scope.row.goodsCount || 0 }} 件商品</div></template>
        </el-table-column>
        <el-table-column label="活动时间" min-width="210" align="center">
          <template slot-scope="scope"><div>{{ formatApiDate(scope.row.startTime) }}</div><div class="secondary-text">至 {{ formatApiDate(scope.row.endTime) }}</div></template>
        </el-table-column>
        <el-table-column label="成团规则" min-width="185" align="center">
          <template slot-scope="scope"><div>{{ scope.row.groupSize }} 人团 · {{ scope.row.groupDurationHours }} 小时</div><div class="secondary-text">虚拟成团：{{ scope.row.virtualEnabled ? "开启" : "关闭" }}</div></template>
        </el-table-column>
        <el-table-column label="已拼份数" min-width="155" align="center">
          <template slot-scope="scope">
            <div class="sold-count">已拼 {{ scope.row.totalSoldNum || 0 }} 份</div>
            <div class="secondary-text">真实 {{ scope.row.realSoldNum || 0 }} + 虚拟 {{ scope.row.virtualSoldNum || 0 }}</div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="105" align="center">
          <template slot-scope="scope"><el-tag :type="phaseMeta(scope.row.phase).type" size="small">{{ phaseMeta(scope.row.phase).label }}</el-tag></template>
        </el-table-column>
        <el-table-column label="操作" width="390" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.phase !== 'ENDED'" type="text" @click="openEditor(scope.row)">编辑</el-button>
            <el-button type="text" @click="goOrders(scope.row)">订单</el-button>
            <el-button type="text" @click="goTeams(scope.row)">统计</el-button>
            <el-button v-if="scope.row.phase === 'ONGOING' && scope.row.virtualEnabled" type="text" @click="openVirtual(scope.row)">虚增拼团</el-button>
            <el-button v-if="scope.row.phase !== 'ENDED'" type="text" class="danger-text" @click="endActivity(scope.row)">结束</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container"><el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total" :page-size="query.pageSize" :current-page="query.page" :page-sizes="[10,20,30,50]" @size-change="sizeChange" @current-change="pageChange" /></div>
    </el-card>
    <ActivityEditor :visible.sync="editorVisible" :activity-id="editingId" @saved="load" />
    <VirtualTeamDialog :visible.sync="virtualVisible" :activity="selectedActivity" @saved="load" />
    <StatisticsDialog :visible.sync="statisticsVisible" :activity-id="statisticsActivityId" />
  </div>
</template>

<script>
import { endGroupBuyActivity, getGroupBuyActivities } from "@/api/groupBuy";
import { formatApiDate } from "@/utils/utils";
import ActivityEditor from "./ActivityEditor.vue";
import VirtualTeamDialog from "./VirtualTeamDialog.vue";
import StatisticsDialog from "./StatisticsDialog.vue";
export default {
  name: "GroupBuyActivityList", components: { ActivityEditor, VirtualTeamDialog, StatisticsDialog },
  data() { return { loading: false, list: [], total: 0, editorVisible: false, editingId: null, virtualVisible:false, selectedActivity:null, statisticsVisible:false, statisticsActivityId:null, phases: [{ label: "未开始", value: "UNSTARTED" }, { label: "进行中", value: "ONGOING" }, { label: "已结束", value: "ENDED" }], query: { name: "", phase: "", page: 1, pageSize: 20 } }; },
  created() { this.load(); },
  methods: {
    formatApiDate,
    phaseMeta(value) { return { UNSTARTED: { label: "未开始", type: "info" }, ONGOING: { label: "进行中", type: "success" }, ENDED: { label: "已结束", type: "" } }[value] || { label: "-", type: "info" }; },
    async load() { this.loading = true; try { const res = await getGroupBuyActivities(this.query); this.list = res.data.entitys || []; this.total = res.data.totalCount || 0; } finally { this.loading = false; } },
    search() { this.query.page = 1; this.load(); }, reset() { this.query = { name: "", phase: "", page: 1, pageSize: 20 }; this.load(); },
    sizeChange(value) { this.query.pageSize = value; this.query.page = 1; this.load(); }, pageChange(value) { this.query.page = value; this.load(); },
    openEditor(row) { this.editingId = row ? row.id : null; this.editorVisible = true; },
    goTeams(row) { this.statisticsActivityId = row.id; this.statisticsVisible = true; },
    openVirtual(row) { this.selectedActivity = row; this.virtualVisible = true; },
    goOrders(row) { this.$router.push({ path: "/activity/group-buy/orders", query: { activityId: row.id } }); },
    endActivity(row) { this.$confirm(`确定要结束拼团活动“${row.name}”吗？进行中的未成团队伍将标记为失败。`, "结束活动", { type: "warning", confirmButtonText: "确定结束", cancelButtonText: "取消" }).then(async () => { await endGroupBuyActivity({ id: row.id }); this.$message.success("活动已结束"); this.load(); }); }
  }
};
</script>
<style scoped lang="scss">
.group-buy-page { background: #f5f7fa; min-height: calc(100vh - 84px); }
.page-heading { display:flex; align-items:center; justify-content:space-between; margin-bottom:18px; }
.page-heading h2 { margin:0 0 7px; color:#303133; font-size:22px; }.page-heading p{margin:0;color:#909399;font-size:13px}
.filter-card{margin-bottom:16px}.filter-card ::v-deep .el-card__body{padding-bottom:2px}.table-card ::v-deep .el-card__body{padding:18px}
.primary-text{font-weight:500;color:#303133}.secondary-text{margin-top:5px;color:#909399;font-size:12px}.danger-text{color:#f56c6c}.pagination-container{text-align:right;margin-top:20px}
.sold-count{color:#303133;font-weight:600;font-variant-numeric:tabular-nums}
</style>
